module.exports = __webpack_public_path__ + "img/quiz-app-sc.07b1d403.png";